var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Add Screening Results",
        visible: true,
        centered: "",
        "header-bg-variant": "success",
        "header-text-variant": "light"
      },
      on: { hide: _vm.closeModal, ok: _vm.addOldTraffickingScreening },
      scopedSlots: _vm._u([
        {
          key: "modal-header-close",
          fn: function() {
            return [_c("h4", [_vm._v("X")])]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "secondary",
                    size: "sm",
                    disabled: _vm.isLoading
                  },
                  on: { click: _vm.closeModal }
                },
                [_vm._v("\n            Cancel\n        ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticStyle: { width: "60px" },
                  attrs: {
                    variant: "primary",
                    size: "sm",
                    disabled: _vm.isLoading
                  },
                  on: { click: _vm.addOldTraffickingScreening }
                },
                [
                  _vm.isLoading
                    ? _c("i", { staticClass: "fa fa-spinner" })
                    : _c("span", [
                        _vm._v("\n                Submit\n            ")
                      ])
                ]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c("p", [
        _c("b", [
          _vm._v(
            "\n        Please select from the drop-down menu below the screening results for the Louisiana Indicator Tool for Child & Youth Sex Trafficking.\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "Screening Results",
            "label-align-sm": "left",
            "label-for": "screening-results"
          }
        },
        [
          _c("b-form-select", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: {
              id: "screening-results",
              "data-vv-name": "conclusion",
              "data-vv-as": "Screening Name",
              options: _vm.conclusionOptions,
              placeholder: "Please select an option"
            },
            model: {
              value: _vm.screening.conclusion,
              callback: function($$v) {
                _vm.$set(_vm.screening, "conclusion", $$v)
              },
              expression: "screening.conclusion"
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.inputValidationErrors.has("conclusion"),
                  expression: "inputValidationErrors.has('conclusion')"
                }
              ],
              staticClass: "text-info"
            },
            [_vm._v(_vm._s(_vm.inputValidationErrors.first("conclusion")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("p", [
        _c("b", [
          _vm._v(
            "\n            If available, upload PDF copy of the Louisiana Indicator Tool for Child & Youth Sex Trafficking by clicking on the button below.\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "custom-file-upload", attrs: { for: "file-upload" } },
        [_vm._v("\n        Upload PDF\n    ")]
      ),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.screening.fileName))]),
      _vm._v(" "),
      _c("input", {
        attrs: { disabled: _vm.isLoading, type: "file", id: "file-upload" },
        on: { change: _vm.onFileUpload }
      }),
      _vm._v(" "),
      _c("p", [_c("b", [_vm._v("Comments")])]),
      _vm._v(" "),
      _c("b-form-textarea", {
        staticClass: "mt-3",
        attrs: { rows: "10", placeholder: "Enter Comments", name: "comments" },
        model: {
          value: _vm.screening.comments,
          callback: function($$v) {
            _vm.$set(_vm.screening, "comments", $$v)
          },
          expression: "screening.comments"
        }
      }),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          attrs: {
            fade: "",
            show:
              _vm.createOldTraffickingScreeningError ||
              _vm.createOldTraffickingScreeningSuccess,
            variant: _vm.createOldTraffickingScreeningError
              ? "danger"
              : "success"
          }
        },
        [
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.apiResponseMessage) }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5eff8b8d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eff8b8d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/AddOldTraffickingScreeningModal.vue
// module id = 1628
// module chunks = 0